import { css } from '@emotion/react'

export const maxWidth = {
  tablet: {
    maxContentWidth: css`
      max-width: 1280px;
    `,
  },
}
